module.exports = __webpack_public_path__ + "static/img/组 2883.6488b78.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/agency/images/组 2883.png
// module id = vbyo
// module chunks = 0